import React from "react";

import Paper from "../../../../../componentsv2/Paper";
import SelectEnfermeiro from "../../../Components/SelectEnfermeiro";
import calcularPercentualBarra from "../utils/calcularPercentualBarra";

export default function TabelaAtendimentosEnfermeiro({
  enfermeiroId,
  onChangeEnfermeiro,
  atendimentos = [],
  totalAtendimentos = 0,
}) {
  const maiorValor = atendimentos.reduce(
    (maior, item) => Math.max(maior, Number(item.totalAtendimentos || 0)),
    0
  );

  return (
    <Paper style={{ padding: "20px", borderRadius: "12px", marginTop: "16px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "24px",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        <div>
          <h3 style={{ margin: 0, color: "#202638", fontSize: "16px" }}>
            Atendimentos por Enfermeiro
          </h3>
          <p style={{ margin: "6px 0 0", color: "#7C8798", fontSize: "13px" }}>
            Volume de atendimentos realizados por profissional
          </p>
        </div>
        <div style={{ minWidth: "260px", maxWidth: "360px", width: "100%" }}>
          <SelectEnfermeiro
            todos
            value={enfermeiroId}
            onChange={onChangeEnfermeiro}
          />
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        <div style={{ minWidth: "640px" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1.4fr 120px 1fr",
              gap: "16px",
              padding: "0 0 12px",
              borderBottom: "1px solid #ECEFF1",
              color: "#9AA3AF",
              fontSize: "12px",
              fontWeight: 700,
            }}
          >
            <span>ENFERMEIRO</span>
            <span style={{ textAlign: "center" }}>ATENDIMENTOS</span>
            <span />
          </div>

          {!atendimentos.length && (
            <div style={{ color: "#7C8798", fontSize: "14px", padding: "28px 0" }}>
              Nenhum atendimento encontrado para o período.
            </div>
          )}

          {atendimentos.map(item => {
            const percentual = calcularPercentualBarra(item.totalAtendimentos, maiorValor);

            return (
              <div
                key={item.enfermeiroId || item.nome}
                style={{
                  display: "grid",
                  gridTemplateColumns: "1.4fr 120px 1fr",
                  gap: "16px",
                  alignItems: "center",
                  padding: "16px 0",
                  borderBottom: "1px solid #F2F4F7",
                }}
              >
                <strong style={{ color: "#202638", fontSize: "14px" }}>{item.nome}</strong>
                <span
                  style={{
                    justifySelf: "center",
                    minWidth: "38px",
                    padding: "4px 10px",
                    borderRadius: "999px",
                    color: "#1F3FA3",
                    backgroundColor: "#EEF2FF",
                    textAlign: "center",
                    fontWeight: 700,
                  }}
                >
                  {item.totalAtendimentos}
                </span>
                <div
                  style={{
                    height: "8px",
                    backgroundColor: "#E5E7EB",
                    borderRadius: "999px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: `${percentual}%`,
                      height: "100%",
                      backgroundColor: "#1F3FA3",
                      borderRadius: "999px",
                    }}
                  />
                </div>
              </div>
            );
          })}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1.4fr 120px 1fr",
              gap: "16px",
              alignItems: "center",
              paddingTop: "16px",
            }}
          >
            <strong style={{ color: "#202638", fontSize: "14px" }}>Total</strong>
            <span
              style={{
                justifySelf: "center",
                minWidth: "44px",
                padding: "6px 12px",
                borderRadius: "999px",
                color: "#FFFFFF",
                backgroundColor: "#1F3FA3",
                textAlign: "center",
                fontWeight: 800,
              }}
            >
              {totalAtendimentos}
            </span>
            <span />
          </div>
        </div>
      </div>
    </Paper>
  );
}
